export const form = {
  formCopyLink: 'Link kopieren',
  formLinkCopied: 'Link kopiert!'
}
